export enum TestIds {
  testId = 'test-id',
  floatingLabelRoot = 'floating-label-root-test-id',
  floatingLabelBg = 'floating-label-bg-test-id',
  floatingLabel = 'floating-label-test-id',
}
